import * as React from "react";
import { forwardRef } from "react";
const SvgMapPoint = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 34, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M24.034 12c0 3.627-3.594 9.723-6.848 14.5-2.692 3.952-5.152 7-5.152 7s-2.46-3.048-5.152-7C3.628 21.723.034 15.627.034 12c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12Z" }));
const ForwardRef = forwardRef(SvgMapPoint);
export default ForwardRef;
